export function russianPlural(choice, choicesLength) {
  const n = Math.abs(Number(choice))
  const integer = Number.isInteger(n)
  const one = integer && n % 10 === 1 && n % 100 !== 11
  const few = integer && n % 10 >= 2 && n % 10 <= 4 && !(n % 100 >= 12 && n % 100 <= 14)
  if (choicesLength === 1) return 0
  if (choicesLength === 2) return one ? 0 : 1
  const offset = choicesLength >= 4 ? 1 : 0
  if (offset && n === 0) return 0
  return (one ? 0 : few ? 1 : 2) + offset
}
